import axios from "axios";
import constants from "../../utils/constants";

const baseURL=constants.BACKEND;

const findQuestions = () => {
    return axios
        .get(`${baseURL}webpage/findAllQuestions`);
};

const findAllProfile = () => {
    return axios
        .get(`${baseURL}webpage/findAllProfile`);
};

const findAllAllocations = () => {
    return axios
        .get(`${baseURL}webpage/findAllAllocations`);
};

const findAllStats = () => {
    return axios
        .get(`${baseURL}webpage/findAllStats`);
};

const QuestionService = {
    findQuestions,
    findAllProfile,
    findAllAllocations,
    findAllStats
}

export default QuestionService;